import {API_URL} from "../../dev";
import "isomorphic-fetch";

class ShoppingCartApi {
	async createShoppingCart(merchantId, themeName) {
		try {
			const shoppingcartResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}`, {
					method: 'POST',
				});
			const shoppingCartObj = await shoppingcartResponse.json();
			if (shoppingcartResponse.ok) {
				return shoppingCartObj;
			}
			throw shoppingCartObj;
		} catch (e) {
			console.error(`Error occurred in createShoppingCart: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async addTickets(merchantId, themeName, secureId, eventUuid, ticketDTOs) {
		try {
			const shoppingcartResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}/${secureId}/${eventUuid}/tickets`, {
					method: 'POST',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(ticketDTOs),
				});
			const shoppingCartObj = await shoppingcartResponse.json();
			if (shoppingcartResponse.ok) {
				return shoppingCartObj;
			}
			throw shoppingCartObj;
		} catch (e) {
			console.error(`Error occurred in addTickets: ${JSON.stringify(e)}`);
			throw e;
		}
	}


	async removeTickets(merchantId, themeName, secureId, ticketItemUuids) {
		function buildParams(acc, val, i) {
			return i > 0 ? `${acc}&ticketItemUuids=${val}` : `${acc}${val}`;
		}
		const paramString = ticketItemUuids.reduce(
			buildParams,
			'?ticketItemUuids='
		);
		try {
			const shoppingcartResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}/${secureId}` +
				`/tickets${paramString}`, {
					method: 'DELETE',
				});
			const shoppingCartObj = await shoppingcartResponse.json();
			if (shoppingcartResponse.ok) {
				return shoppingCartObj;
			}
			throw shoppingCartObj;
		} catch (e) {
			console.error(`Error occurred in removeTickets: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async removeTicketsByEventUuid(merchantId, themeName, secureId, eventUuid) {
		try {
			const shoppingcartResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}/${secureId}` +
				`/tickets/by-event-uuid?eventUuid=${eventUuid}`, {
					method: 'DELETE',
				});
			const shoppingCartObj = await shoppingcartResponse.json();
			if (shoppingcartResponse.ok) {
				return shoppingCartObj;
			}
			throw shoppingCartObj;
		} catch (e) {
			console.error(`Error occurred in removeTicketsByEvenUuid: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async clearShoppingcart(merchantId, themeName, secureId) {
		try {
			const shoppingcartResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}/${secureId}/tickets/all`, {
					method: 'DELETE',
				});
			const shoppingCartObj = await shoppingcartResponse.json();
			if (shoppingcartResponse.ok) {
				return shoppingCartObj;
			}
			throw shoppingCartObj;
		} catch (e) {
			console.error(`Error occurred in clearShoppingcart: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async addVisualTicket(merchantId, themeName, secureId, eventUuid, ticketDTO) {
		try {
			const shoppingcartResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}/${secureId}/${eventUuid}/visualTicket`, {
					method: 'POST',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(ticketDTO),
				});
			const shoppingCartObj = await shoppingcartResponse.json();
			if (shoppingcartResponse.ok) {
				return shoppingCartObj;
			}
			throw shoppingCartObj;
		} catch (e) {
			console.error(`Error occurred in addTickets: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async updateVisualBulkTicket(merchantId, themeName, secureId, eventUuid, ticketDTO) {
		try {
			const shoppingcartResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}/${secureId}/${eventUuid}/updateVisualBulkTickets`, {
					method: 'POST',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(ticketDTO),
				});
			const shoppingCartObj = await shoppingcartResponse.json();
			if (shoppingcartResponse.ok) {
				return shoppingCartObj;
			}
			throw shoppingCartObj;
		} catch (e) {
			console.error(`Error occurred in addVisualBulkTicket: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async getDisplayShoppingCart(merchantId, themeName, secureId) {
		try {
			const displayShoppingCartResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}/${secureId}/display`, {
					method: 'GET',
				});
			const displayShoppingCartObject = await displayShoppingCartResponse.json();
			if (displayShoppingCartResponse.ok) {
				return displayShoppingCartObject;
			}
			throw displayShoppingCartObject;
		} catch (e) {
			console.error(`Error occurred in getDisplayShoppingCart: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async updateTicketPriceLevels(merchantId, themeName, secureId, ticketItemUuids, priceLevelUuid) {
		try {
			const priceLevelUpdateDto = {
				priceLevelUuid,
				ticketItemUuids,
			};

			const shoppingCartResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}/
				${secureId}/ticketItems/pricelevel`, {
					method: 'PUT',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(priceLevelUpdateDto),
				});
			const ShoppingCartObj = await shoppingCartResponse.json();
			if (shoppingCartResponse.ok) {
				return ShoppingCartObj;
			}
			throw ShoppingCartObj;
		} catch (e) {
			console.error(`Error occurred in updateTicketPriceLevels ${secureId}, ${priceLevelUuid}:` +
					`${JSON.stringify(e)}`,
					`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}/
					${secureId}/ticketItems/pricelevel`);
			throw e;
		}
	}

	async hasTimeExpired(expirationTime) {
		try {
			const hasTimeExpiredResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/hasTimeExpired?expirationTime=${expirationTime}`, {
					method: 'GET',
				});
			const expiredDto = await hasTimeExpiredResponse.json();
			if (hasTimeExpiredResponse.ok) {
				return expiredDto;
			}
			throw expiredDto;
		} catch (e) {
			console.error(`Error occurred in hasTimeExpired: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async getShipmentTypesForShoppingCart(merchantId, themeName, secureId, bookingOffice) {
		try {
			const shipmentTypesForShoppingCartResponse = await fetch(
				`${API_URL}/v1/shoppingCarts/${merchantId}_${themeName}/${secureId}/${bookingOffice}/shipmentTypes`, {
					method: 'GET',
				});
			const shipmentTypesForShoppingCartObject = await shipmentTypesForShoppingCartResponse.json();
			if (shipmentTypesForShoppingCartResponse.ok) {
				return shipmentTypesForShoppingCartObject;
			}
			throw shipmentTypesForShoppingCartObject;
		} catch (e) {
			console.error(`Error occurred in getShipmentTypesForShoppingCart: ${JSON.stringify(e)}`);
			throw e;
		}
	}
}

const shoppingCartApi = new ShoppingCartApi();
export default shoppingCartApi;
